import Image1 from '../../assets/project1.png'
import Image2 from '../../assets/project2.jpeg'
import Image3 from '../../assets/project3.jpeg'
// import Image4 from '../../assets/project4.jpg'
// import Image5 from '../../assets/project5.jpg'
import Image6 from '../../assets/project6.jpg'
import Image7 from '../../assets/project7.jpeg'
// import Image8 from '../../assets/project8.jpg'
import Image9 from '../../assets/project9.jpeg'
import Image10 from '../../assets/project10.jpeg'

const data = [
    {
        id: 1,
        category: 'uiux',
        image: Image1,
        title: " Smart Luncher",
        desc: "A responsive web page design called Smart luncher adapts to different screen sizes and devices, providing a user-friendly and visually appealing website. It automatically adjusts layout, text, and images for an optimal viewing experience.",
        demo: 'https://bitluncher.pages.dev/',
        github: 'https://github.com/MilanAarick/S-L-Landing-Page'
    },
    {
        id: 2,
        category: 'frontend',
        image: Image2,
        title: "Meme Picker",
        desc: "Meme-picker is a web app that allows users to easily search and find memes to share with friends. With its user-friendly interface and wide selection of memes, it has become a popular choice for those looking to add a little humor to their social media posts. ",
        demo: '#',
        github: 'https://github.com/egattor'
    },
    {
        id: 3,
        category: 'frontend',
        image: Image3,
        title: "WISORC",
        desc: "Introducing Wisorc, the exciting new web app for dice game enthusiasts! In this thrilling battle, players take on the role of either a wizard or an orc, rolling dice to cast spells and defeat their opponent. With a variety of spells and abilities to choose from, every game is unique and filled with action.",
        demo: '#',
        github: 'https://github.com/MilanAarick/wissorc'
    },
    // {
    //     id: 4,
    //     category: 'uiux',
    //     image: Image4,
    //     title: "Wallpaper (Browser Extention)",
    //     desc: "Introducing Monitor Wallpaper, the ultimate browser extension for staying on top of the latest crypto prices, time, and weather. With real-time updates on the market, your desktop background will always be up-to-date, making it easy to track your investments and stay on top of the latest trends. ",
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/egattor'
    // },
    // {
    //     id: 5,
    //     category: 'uiux',
    //     image: Image5,
    //     title: "Meme-Gen (UIUX)",
    //     desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! ",
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/MilanAarick/Meme-Gen'
    // },
    {
        id: 6,
        category: 'frontend',
        image: Image6,
        title: "Tenzies",
        desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
        demo: '#',
        github: 'https://github.com/MilanAarick/Tenzies'
    },
    {
        id: 7,
        category: 'frontend',
        image: Image7,
        title: "Picsome",
        desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
        demo: '#',
        github: 'https://github.com/MilanAarick/ShoppingCart'
    },
    // {
    //     id: 8,
    //     category: 'frontend',
    //     image: Image8,
    //     title: "Project Title Eight ",
    //     desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/egattor'
    // },
    {
        id: 9,
        category: 'frontend',
        image: Image9,
        title: "BlackJack",
        desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
        demo: '#',
        github: 'https://github.com/MilanAarick/BlackJack'
    },
   
    {
        id: 10,
        category: 'frontend',
        image: Image10,
        title: "Annoying Cookies",
        desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
        demo: '#',
        github: 'https://github.com/MilanAarick/Annoying-Cookies'
    }
]


export default data